$(function() {

	var $grid;

	var tourCreateIsotope = function() {
		if (!isBreakpoint('xs') && !isBreakpoint('sm')) {
			$grid = $(".isotope-grid").isotope({
				itemSelector: '.grid-item',
			});
		}
	};

	var isBreakpoint = function(alias) {
		return $('.device-' + alias).is(':visible');
	};

	tourCreateIsotope();

	filters = [];
	$('#content').on('change', '.tour-filter .filter select.filter-select', function() {
		var name = $(this).attr('name');
		var value = $(this).val();

		if (!$(this).val()) {
			filters[name] = '';
		} else {
			filters[name] = '.' + name + '-' + value;
		}

		console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', concatValues(filters));

		$grid.isotope({ filter: concatValues(filters) });
		$grid.isotope('getFilteredItemElements');
	});

	$('#content').on('click', '.tour-filter button', function() {
		$(".tour-filter select.filter-select").val('');
		// $(".tour-filter select.filter option:first").attr('selected', 'selected');
		$grid.isotope({ filter: '*' });
		$grid.isotope('getFilteredItemElements');
	});
});

// flatten object by concatting values
function concatValues(obj) {
	var value = '';
	for (var prop in obj) {
		value += obj[prop];
	}
	return value;
}